module.exports = __webpack_public_path__ + "img/handimage1.83f9ccea.png";